module.exports = __webpack_public_path__ + "img/bdedaf3.jpg";